import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {
    withMarkConversion,
    type WithMarkConversionProps,
    type WithoutMarkConversion,
} from "@khan/analytics-learning-time";

import StudentAssignments from "#assignments-package/student-assignments/index.tsx";
import ModalNavigator from "#content-library-legacy/components/modal-navigator.tsx";
import modalNavigatorStore from "#content-library-legacy/redux/modal-navigator-store.ts";
import {Provider} from "#data-access/react-redux-provider.tsx";

type OwnProps = {
    kaid: string;
    classroomDescriptor: string;
    hasActiveAssignments: boolean;
    loading: boolean;
    refetchHomepageQuery: () => void;
    onSufficientlyUsable: () => void;
};

type Props = OwnProps & WithMarkConversionProps;

class Assignments extends React.Component<Props> {
    componentDidMount() {
        const {markConversion} = this.props;

        markConversion({id: "logged_in_homepage_visit"});
    }

    render(): React.ReactNode {
        const {
            classroomDescriptor,
            loading,
            hasActiveAssignments,
            refetchHomepageQuery,
            onSufficientlyUsable,
        } = this.props;
        return (
            <View testId="assignments">
                <View style={styles.container}>
                    <StudentAssignments
                        classroomDescriptor={classroomDescriptor}
                        hasActiveAssignments={hasActiveAssignments}
                        loadingHasActiveAssignments={loading}
                        refetchHasActiveAssignments={refetchHomepageQuery}
                        onSufficientlyUsable={onSufficientlyUsable}
                    />
                    <Provider store={modalNavigatorStore}>
                        <ModalNavigator
                            showEditorShortcuts={false}
                            inPractice={true}
                            hostInBody={true}
                        />
                    </Provider>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        marginBottom: 32,
    },
});

type ExportProps = WithoutMarkConversion<
    JSX.LibraryManagedAttributes<
        typeof Assignments,
        React.ComponentProps<typeof Assignments>
    >
>;

const AssignmentsWithLearningTime: React.ComponentType<ExportProps> =
    withMarkConversion(Assignments);
export default AssignmentsWithLearningTime;
